import * as React from 'react';
import {GROUP} from '../../../constants/LabelConstants';
import {GroupMigrationProps} from '../../../types/mx/components';

class GroupMigrationView extends React.Component<GroupMigrationProps, {}> {

    renderMigrationSuccess(originGroup, targetGroup, isSuccess, numberRequests, migrationResult) {
        if (isSuccess) {
            return <p>
                Se migraron {migrationResult} solicitudes desde {originGroup.value}&nbsp; hacia el
                grupo {targetGroup.value}.
            </p>;
        }
        return <React.Fragment>
            <p>
                Estas a punto de migrar {numberRequests} solicitudes asociadas desde {originGroup.value}&nbsp;
                hacia el grupo {targetGroup.value}.
            </p>
            <p>
                Esta opción no se puede deshacer.
            </p>
        </React.Fragment>;
    }

    renderButton(isSuccess, onPressMigrationConfirm, onPressClose) {
        if (isSuccess) {
            return <a className="h-auto btn btn-link border-0 btn-form text-primary py-0 pr-0"
               onClick={onPressClose}>{GROUP.MIGRATE_GROUP_FINISH_BUTON}</a>;
        }
        return <React.Fragment><a className="h-auto btn btn-link border-0 btn-form text-secondary-lighten-5 py-0"
                       onClick={onPressClose}>{GROUP.MIGRATE_GROUP_CANCEL_BUTON}</a>
            <a className="h-auto btn btn-link border-0 btn-form text-primary py-0 pr-0"
               onClick={onPressMigrationConfirm}>{GROUP.MIGRATE_GROUP_CONFIRM_BUTON}</a></React.Fragment>;
    }

    render() {
        const {
            numberRequests, originGroup, targetGroup, onPressMigrationConfirm,
            onPressClose, isSuccess, migrationResult
        } = this.props;
        return (
            <div className="col-12 p-0">
                <div className="text-justify">
                    {this.renderMigrationSuccess(originGroup, targetGroup, isSuccess, numberRequests, migrationResult)}
                </div>
                <div className="pt-3 px-0 text-right border-top">
                    {this.renderButton(isSuccess, onPressMigrationConfirm, onPressClose)}
                </div>
            </div>
        );
    }
}

export default GroupMigrationView;